<template>
  <Modal
    :title="title"
    :width="width"
    v-model="showDialog"
    :mask-closable="false" sticky reset-drag-position :mask="false" draggable
    @on-visible-change="closeDialog"
  >
    <div class="label_line">
      反问动作配置
    </div>
    <div class="param">
      <template
        v-for="(action,index) in data">
        <div :key="`askaction`+index" style="margin-bottom: 10px">
          <!--action-->
          <Select
            v-model="action.askAgainType"
            size="default"
            @change="changeAction(index)"
            transfer
            style="width: 45%"
            placeholder="请选择反问方式">
            <Option
              v-for="item in actions"
              :key="`askitemAction`+item.action"
              :label="item.label"
              :value="item.value">
            </Option>
          </Select>
          <!--file-->
          <Select
            size="default"
            style="width: 50%"
            v-show="action.askAgainType!==1"
            v-model="action.askAgainFileId"
            transfer
            @change="changeFile"
            placeholder="请选择语音文件">
            <Option
              v-for="param in fileList"
              :key="`param`+param.id"
              :label="param.name"
              :value="param.id">
            </Option>
          </Select>
          <!--word-->
          <el-input size="small" style="width: 50%" v-model="action.askAgainTxt" v-show="action.askAgainType===1" placeholder="请输入文字"></el-input>
          <!--<i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteAction(action)"></i>-->
        </div>
      </template>
      <!--<a @click="addAction" class="param">+新增动作</a>-->
    </div>
    <div slot="footer">
      <el-button type="primary" @click.prevent="submitAsk" size="small">确定</el-button>
      <el-button @click="cancelAsk" size="small">取消</el-button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "AskDialog",
    props:{
      askId: {
        type:String/Number,
        default:''
      },
      show:{
        type:Boolean,
        default: false,
      },
      askData:{
        type:Array,
        default:()=>[]
      },
      fileList: {
        type:Array,
        default:()=>[]
      }
    },
    data() {
      return {
        data:[],
        paramData:[],
        configData:[],
        showDialog: false,
        width:500,
        title:'通过反问配置收集缺失信息',
        actions:[
          {action:'playFile',label:'播放文件',value:0},
          {action:'playTTS',label:'播放文字',value:1}
        ],//action 动作集合
      }
    },
    methods:{
      closeDialog(val) {
        this.$emit('close',val)
      },
      changeAction(index) {
        //修改参数为下标行号
      },
      changeFile() {

      },
      cancelAsk() {
        this.showDialog=false
      },
      deleteAction(action) {
        let index = this.actionList.indexOf(action)
        if (index !== -1) {
          this.actionList.splice(index, 1)
        }
      },
      addAction() {
        this.actionList.push({id:'',action:1,paramId:'',word: '',key:Date.now()})
      },
      submitAsk() {
        this.$emit('updateParams',this.data)
        this.showDialog = false
      }
    },
    watch:{
      askId:{
        deep:true,
        immediate:true,
        handler(val) {
        }
      },
      askData:{
        deep:true,
        immediate:true,
        handler(value){
          this.data = []
          this.data = [].concat(value)
          if (value.length>0) {
            if (this.show) {
              this.showDialog = true
            }
          }
        }
      },
      show:{
        deep:true,
        handler(val) {
          //this.showDialog = val
        }
      }
    }
  }
</script>

<style scoped lang="css">
  .label_line{
    height: 35px;
    line-height: 35px;
    text-align: left;
    background-color: #D3DCE6;
    width: 107%;
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
  }
  .param{
    margin: 10px;
  }
  a{
    color: #3da8f1;
  }
</style>



// WEBPACK FOOTER //
// src/components/flow/components/AskDialog.vue